import {
  Card,
  CardContent,
  CircularProgress,
  Grid,
  SxProps,
  Theme,
  Typography,
  useTheme,
} from "@mui/material";
import BulkUploadProgress from "components/BulkUploadProgress";
import { useEffect } from "react";
import { importsBulkUploadStore } from "stores/importsUploadStore";
import { useIntl } from "react-intl";

type ImportUsersFileUploadingProps = {
  onProcessingFinished: () => void;
};

const useStyles = (theme: Theme): { [key: string]: SxProps } => ({
  root: {
    minWidth: 275,
    backgroundColor: "#F5F5F5",
  },
  title: {
    fontSize: "24px",
    color: "red",
  },
});

export function ImportUsersFileUploading({
  onProcessingFinished,
}: Readonly<ImportUsersFileUploadingProps>) {
  const styles = useStyles(useTheme());
  const { formatMessage: t } = useIntl();

  const { bulkUploadProgressStatus, uploadCompleted } =
    importsBulkUploadStore.useState((s) => ({
      bulkUploadProgressStatus: s.bulkUploadProgressStatus,
      shouldAbortUpload: s.shouldAbortUpload,
      uploadCompleted: s.uploadCompleted,
    }));

  useEffect(() => {
    if (uploadCompleted) {
      onProcessingFinished();
    }
  }, [onProcessingFinished, uploadCompleted]);

  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} sm={12} md={12}>
        <Card sx={styles.root}>
          <CardContent>
            {!uploadCompleted && (
              <>
                <Typography
                  variant="h5"
                  component="h2"
                  style={{ marginTop: 15, marginBottom: 15 }}
                >
                  {t({ id: "progress" })}: {Math.floor(bulkUploadProgressStatus!)} %
                </Typography>
                <CircularProgress size={32} />
              </>
            )}
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={12} md={12}>
        <BulkUploadProgress type="imports" />
      </Grid>
    </Grid>
  );
}
